<template>
  <form @submit="submit">
    <modal :show="showModal" @close="closeModal()" size="md">
      <div
        slot="header"
        class="d-flex justify-content-between align-items-center w-100"
      >
        Eksportuj
      </div>

      <div slot="body">
        <div class="col-24">
          <div class="row">
            <div class="mb-4 col-24">
              <div class="product-form__title">Nazwa głównego węzła</div>
              <input
                class="product-form__input product-form__input--validate"
                type="text"
                v-model="form.root"
                pattern="^[a-zA-Z0-9_]*$"
                placeholder="SHOP"
                @input="validateTagName('root', $event.target.value)"
              />
              <div v-if="errors['root']" class="product-form__input-error">
                {{ errors["root"] }}
              </div>
            </div>

            <div class="mb-4 col-24">
              <div class="product-form__title">Nazwa węzłów produktowych</div>
              <input
                class="product-form__input product-form__input--validate"
                type="text"
                v-model="form.item_name"
                pattern="^[a-zA-Z0-9_]*$"
                placeholder="SHOP_ITEM"
              />
            </div>

            <div class="mb-4 col-24">
              <div class="product-form__title">Język</div>
              <treeselect
                class="vue-treeselect"
                v-if="languages.length > 0"
                v-model="form.locale"
                :multiple="false"
                :options="languages"
                placeholder="Wybierz język"
                :clearable="true"
                :disable-branch-nodes="true"
                :disabled="false"
              />
              <div
                v-else
                class="product-form__note"
                v-text="
                  isLoading
                    ? 'Ładowanie...'
                    : 'Wystąpił problem podczas ładowania języków'
                "
              ></div>
            </div>

            <div class="mt-2 mb-4 col-24">
              <div class="product-form__title product-form__title--medium">
                Dane do eksportu
              </div>
              <label class="product-form__checkbox mt-3 mb-1">
                <input
                  class="product-form__checkbox--input"
                  type="checkbox"
                  v-model="form.with_variants"
                />
                <span class="product-form__checkbox-checkmark"
                  >Produkt z wariantami</span
                >
              </label>
            </div>

            <div class="mb-4 col-24">
              <div class="product-form__title">Pola produktowe</div>
              <treeselect
                class="vue-treeselect"
                v-if="fields.product && fields.product.length > 0"
                v-model="selectedFields.product"
                :multiple="true"
                :options="fields.product"
                placeholder="Wybierz pola"
                :clearable="true"
                :disable-branch-nodes="true"
                :disabled="false"
              />
              <div
                v-else
                class="product-form__note"
                v-text="
                  isLoading
                    ? 'Ładowanie...'
                    : 'Wystąpił problem podczas ładowania pól'
                "
              ></div>
            </div>

            <div v-if="selectedFields.product.length" class="col-24 mt-n2 mb-4">
              <div class="product-form--gray pt-3 pb-1 px-2">
                <div
                  v-for="selectedField in selectedFields.product"
                  :key="selectedField"
                  class="mb-4 mt-2 col-24"
                >
                  <div class="product-form__title">
                    Pole produktowe:
                    {{
                      fields.product.find(({ id }) => id === selectedField)
                        .label
                    }}
                  </div>
                  <input
                    class="product-form__input product-form__input--validate"
                    type="text"
                    v-model="names[selectedField]"
                    pattern="^[a-zA-Z0-9_]*$"
                    required
                    @input="validateTagName(selectedField, $event.target.value)"
                  />
                  <div
                    v-if="errors[selectedField]"
                    class="product-form__input-error"
                  >
                    {{ errors[selectedField] }}
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-4 col-24">
              <div class="product-form__title">Pola logistyczne</div>
              <treeselect
                class="vue-treeselect"
                v-if="fields.logistics_data && fields.logistics_data.length > 0"
                v-model="selectedFields.logistics_data"
                :multiple="true"
                :options="fields.logistics_data"
                placeholder="Wybierz pola"
                :clearable="true"
                :disable-branch-nodes="true"
                :disabled="false"
              />
              <div
                v-else
                class="product-form__note"
                v-text="
                  isLoading
                    ? 'Ładowanie...'
                    : 'Wystąpił problem podczas ładowania pól'
                "
              ></div>
            </div>

            <div
              v-if="selectedFields.logistics_data.length"
              class="col-24 mt-n2 mb-4"
            >
              <div class="product-form--gray pt-3 pb-1 px-2">
                <div
                  v-for="selectedField in selectedFields.logistics_data"
                  :key="selectedField"
                  class="mb-4 mt-2 col-24"
                >
                  <div class="product-form__title">
                    Pole logistyczne:
                    {{
                      fields.logistics_data.find(
                        ({ id }) => id === selectedField
                      ).label
                    }}
                  </div>
                  <input
                    class="product-form__input product-form__input--validate"
                    type="text"
                    v-model="names[selectedField]"
                    pattern="^[a-zA-Z0-9_]*$"
                    required
                    @input="validateTagName(selectedField, $event.target.value)"
                  />
                  <div
                    v-if="errors[selectedField]"
                    class="product-form__input-error"
                  >
                    {{ errors[selectedField] }}
                  </div>
                </div>
              </div>
            </div>

            <div class="mb-4 col-24">
              <div class="product-form__title">Atrybuty</div>
              <treeselect
                class="vue-treeselect"
                v-if="attrs.length > 0"
                v-model="selectedAttrs"
                :multiple="true"
                :options="attrs"
                placeholder="Wybierz atrybuty"
                :clearable="true"
                :disable-branch-nodes="true"
                :disabled="false"
              />
              <div
                v-else
                class="product-form__note"
                v-text="
                  isLoading
                    ? 'Ładowanie...'
                    : 'Wystąpił problem podczas ładowania atrybutów'
                "
              ></div>
            </div>

            <div v-if="selectedAttrs.length" class="col-24 mt-n2">
              <div class="product-form--gray pt-3 pb-1 px-2">
                <div
                  v-for="selectedAttr in selectedAttrs"
                  :key="selectedAttr"
                  class="mb-4 mt-2 col-24"
                >
                  <div class="product-form__title">
                    Atrybut:
                    {{ attrs.find(({ id }) => id === selectedAttr).label }}
                  </div>
                  <input
                    class="product-form__input product-form__input--validate"
                    type="text"
                    v-model="names[selectedAttr]"
                    pattern="^[a-zA-Z0-9_]*$"
                    required
                    @input="validateTagName(selectedAttr, $event.target.value)"
                  />
                  <div
                    v-if="errors[selectedAttr]"
                    class="product-form__input-error"
                  >
                    {{ errors[selectedAttr] }}
                  </div>
                </div>
              </div>
            </div>

            <div v-if="noFieldsSelected" class="product-form__note col-24">
              Wybierz przynajmniej jedno pole lub atrybut.
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="d-flex align-items-center">
        <button type="button" class="button button--grey" @click="closeModal()">
          Anuluj
        </button>
        <button
          type="submit"
          class="button button--icon button--ml-10"
          :disabled="noFieldsSelected"
        >
          <icon
            icon="export"
            icon-classes="button__icon button__icon--left icon--white icon__plus--small"
          />
          <span class="button__text">Eksportuj</span>
        </button>
      </div>
    </modal>
  </form>
</template>

<script>
import Modal from "./Modal.vue";
import Icon from "../Icon";
import axios from "axios";
import Treeselect from "@riophae/vue-treeselect";
import _ from "lodash";

export default {
  components: {
    Modal,
    Icon,
    Treeselect,
  },
  data() {
    return {
      form: {
        root: undefined,
        item_name: undefined,
        with_variants: false,
        locale: undefined,
      },
      showModal: false,
      isLoading: false,
      dataLoadInitiated: false,
      attrs: [],
      fields: {},
      languages: [],
      selectedAttrs: [],
      selectedFields: {
        product: [],
        logistics_data: [],
      },
      selected: {},
      names: {},
      errors: {},
    };
  },
  watch: {
    attrs() {
      this.fillDefaultNames(this.attrs);
    },
    fields() {
      this.fillDefaultNames(Object.values(this.fields).flat());
    },
    errors: {
      handler() {
        this.isDifferent = !_.isEqual(this.user, this.compareUser);
      },
      deep: true,
    },
  },
  computed: {
    noFieldsSelected() {
      return (
        [...this.selectedAttrs, ...Object.values(this.selectedFields).flat()]
          .length === 0
      );
    },
  },
  mounted() {
    this.$root.$on("showExportProductsModal", () => {
      this.showModal = true;

      if (!this.dataLoadInitiated) this.loadData();
    });
  },
  beforeDestroy() {
    this.$root.$off("showExportProductsModal");
  },
  methods: {
    async loadData() {
      this.isLoading = true;
      this.dataLoadInitiated = true;

      try {
        this.languages = (
          await axios.get(process.env.VUE_APP_API_BASE_URL + "/languages")
        ).data.map((language) => ({ id: language.code, label: language.name }));

        this.attrs = (
          await axios.get(
            process.env.VUE_APP_API_BASE_URL +
              "/attributes?to_export_only=true",
            {
              headers: {
                locale: "pl",
              },
            }
          )
        ).data.map(({ id, name }) => ({ id: `attributes.${id}`, label: name }));

        this.fields = Object.fromEntries(
          Object.entries(
            (
              await axios.get(
                process.env.VUE_APP_API_BASE_URL + "/api/feed/fields"
              )
            ).data
          ).map(([key, value]) => [
            key,
            value.map(({ field, name }) => ({
              id: `fields.${key}.${field}`,
              label: name,
            })),
          ])
        );
      } catch (error) {
        this.$root.$emit("noticesBox", {
          type: "error",
          message: "Wystąpił problem podczas ładowania pól",
        });
      } finally {
        this.isLoading = false;
      }
    },
    fillDefaultNames(fields) {
      fields.forEach(({ id, label }) => {
        this.names[id] = label
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .replaceAll(" ", "_")
          .replace(/[^a-zA-Z0-9_]/g, "")
          .toUpperCase();
      });
    },
    validateTagName(key, value) {
      console.log(key, value);
      const valid = value.match(/^[a-zA-Z0-9_]*$/) !== null;
      this.errors = {
        ...this.errors,
        [key]: !valid
          ? "Nazwa może zawierać tylko litery, cyfry i podkreślnik."
          : undefined,
      };
    },
    submit(e) {
      e.preventDefault();

      const exportURLParams = [
        ...this.selectedAttrs,
        ...Object.values(this.selectedFields).flat(),
      ]
        .map((id) => {
          const fieldType = id.split(".").at(0);
          const fieldId = id.split(".").at(-1);
          return `${fieldType}[${fieldId}]=${encodeURIComponent(
            this.names[id]
          )}`;
        })
        .concat(
          Object.entries(this.form)
            .filter(([, value]) => !!value)
            .map(([key, value]) => `${key}=${value}`)
        )
        .join("&");

      window.open(
        `${process.env.VUE_APP_API_BASE_URL}/api/feed?${exportURLParams}`,
        "_blank"
      );
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>